/**
 * Shared date/time format tokens (date-fns syntax).
 *
 * These are the canonical formats used across the EthisysCore monolith and
 * plugins. Change a value here for a global locale requirement rather than
 * hardcoding a format string at a call site.
 */

/** ISO wire format `yyyy-MM-dd` — the standard date-only format throughout the app. */
export const DATE_FORMAT = "yyyy-MM-dd";

/** Audit-log timestamp, e.g. `5 March 2026, 14:30`. */
export const AUDIT_DATE_FORMAT = "d MMMM yyyy, HH:mm";

/** User-facing date display, e.g. `5 Mar 2026`. */
export const DISPLAY_DATE_FORMAT = "d MMM yyyy";

/** Weekday + day + month, e.g. `Monday, 5 March`. */
export const DAY_DATE_FORMAT = "EEEE, d MMMM";

/** Abbreviated day + month, e.g. `Mar 5`. */
export const DAY_MONTH_FORMAT = "MMM d";

/** Abbreviated day + month + year, e.g. `Mar 5, 2026`. */
export const DAY_MONTH_YEAR_FORMAT = "MMM d, yyyy";

/** 12-hour time, e.g. `2:30 PM`. */
export const TIME_FORMAT = "h:mm a";

/** Short datetime, e.g. `Mar 5, 2:30 PM`. */
export const SHORT_DATETIME_FORMAT = "MMM d, h:mm a";

/** Milliseconds in a day — whole-day duration / diff math (`daysBetweenIso`, axis geometry). */
export const MS_PER_DAY = 86_400_000;

/** Milliseconds in an hour — duration math without inline `1000 * 60 * 60`. */
export const MS_PER_HOUR = 3_600_000;

/** Milliseconds in a minute — duration / relative-time math without inline `1000 * 60`. */
export const MS_PER_MINUTE = 60_000;

/** Fixed numeric UK date, e.g. `05/03/2026`. Deliberately NOT org-driven — form-field / compact contexts. */
export const DISPLAY_DATE_SLASH_FORMAT = "dd/MM/yyyy";

/** Fixed numeric UK datetime, e.g. `05/03/2026 14:30`. Deliberately NOT org-driven. */
export const DISPLAY_DATETIME_SLASH_FORMAT = "dd/MM/yyyy HH:mm";

/** Weekday + day + abbreviated month, e.g. `Wed 5 Mar`. */
export const DISPLAY_SHORT_DATE_FORMAT = "EEE d MMM";
